<template>
  <main
    :style="[marketplaceInfo?.primaryColorCode ? `--primary-color:${marketplaceInfo?.primaryColorCode}` : '', marketplaceInfo?.fontFamily ? `font-family:${marketplaceInfo?.fontFamily}` : '']"
  >
    <router-view />
  </main>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'App',
  components: {
  },
  computed: {
    ...mapGetters(['marketplaceInfo', 'microAppsUrlParams'])
  },
  data() {
    return {
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.microAppsUrlParams?.m) {
        this.$registerProperties({
          platform: 'web',
          m_code: 'gpay',
          gpay_unique_id: this.microAppsUrlParams?.m
        });
      }
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTION_INITIATED);
    }
  }
};
</script>

<style lang="scss">
@tailwind base;

@tailwind components;

@tailwind utilities;
:root {
  background-color: #F4F5F7;
  --primary-color: #006295;
  --secondary-color: #828E94;
  @supports (accent-color: var(--primary-color)) {
    accent-color: var(--primary-color);
  }
  @supports (accent-color: var(--secondary-color)) {
    accent-color: var(--secondary-color);
  }
}
@layer base {
  [type="text"]:focus,
  [type="email"]:focus,
  [type="url"]:focus,
  [type="password"]:focus,
  [type="number"]:focus,
  [type="date"]:focus,
  [type="datetime-local"]:focus,
  [type="month"]:focus,
  [type="search"]:focus,
  [type="tel"]:focus,
  [type="time"]:focus,
  [type="week"]:focus,
  [multiple]:focus,
  textarea:focus,
  select:focus {
    --tw-ring-color: var(--primary-color);
  }
}
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");
@font-face {
  font-family: "Myriad Pro";
  src: url("./assets/fonts/MyriadPro-Regular.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Myriad Pro";
  font-weight: bold;
  src: url("./assets/fonts/MyriadPro-Bold.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Myriad Pro";
  font-weight: 600;
  src: url("./assets/fonts/MyriadPro-SemiBold.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Mangal";
  src: url("./assets/fonts/Mangal\ Regular.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Blogger Sans";
  src: url("./assets/fonts/Blogger\ Sans.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Blogger Sans";
  src: url("./assets/fonts/Blogger\ Sans\ Medium.ttf") format("truetype");
  font-weight: 600;
  font-display: swap;
}
@font-face {
  font-family: "Blogger Sans";
  src: url("./assets/fonts/Blogger\ Sans\ Bold.ttf") format("truetype");
  font-weight: bold;
  font-display: swap;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
input:invalid {
  box-shadow: none;
}
.bg-down-arrow {
  background-image: url("./assets/down-arrow.svg");
  background-position: 95% 50%;
  background-size: 0.75rem;
}
.bg-details-arrow {
  background-image: url("./assets/primary-arrow.svg");
  background-position: 95% 50%;
  &--modified {
    background-position: 98% 50%;
  }
}
.bg-details-gray-arrow {
  background-image: url("./assets/gray-up-arrow.svg");
  background-position: 95% 50%;
  &--modified {
    background-position: 98% 50%;
  }
}
details[open] {
  .bg-details-arrow {
    background-image: url("./assets/primary-down-arrow.svg");
  }
  .bg-details-gray-arrow {
    background-image: url("./assets/gray-down-arrow.svg");
  }
}
details summary::-webkit-details-marker {
  display: none;
}
.bg-nach-preview {
  background-image: url("./assets/nach-preview.jpg");
}
.bg-signup {
  background-image: url("./assets/sign-up.jpg");
}
form.errors {
  :invalid {
    border: 2px solid #dc2626;
  }
}
.input {
  @apply shadow-cardShadow opacity-100 h-16 font-blogger py-1 px-4 rounded-2xl w-full border-none font-semibold focus:ring-0 focus:outline-none placeholder-gray-300;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--w-32 {
    @apply md:w-32;
  }
  &--single {
    @apply text-center font-semibold md:h-28 h-16 md:w-28 w-16  md:text-5xl text-2xl;
  }
  &--calenderCustomizePx {
    @apply px-1;
  }
}
.input_error {
  @apply border-red-700 border focus:ring-red-700  focus:border-red-700 disabled:bg-white  disabled:text-gray-400 shadow-cardShadow opacity-100 h-16 font-blogger py-1 px-4 rounded-2xl w-full font-semibold placeholder-gray-300;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--single {
    @apply text-center focus:bg-red-700 focus:text-white font-semibold w-10 border border-red-700;
  }
}
.aadharInput {
  @apply text-base px-1 md:px-2  py-1 rounded  border-primary border w-full placeholder-gray-300 focus:outline-none  focus:border-primary disabled:bg-white  disabled:text-gray-400;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--single {
    @apply text-center focus:bg-primary focus:text-white font-semibold w-6 border-2 md:w-8 border-primary;
  }
}
.input-file {
  @apply opacity-0 w-full h-10 cursor-pointer z-10 absolute;
}
.btn {
  @apply md:text-2xl md:h-20 h-16 text-base rounded-xl font-semibold font-blogger flex  items-center justify-center focus:outline-none relative;
  &--primary {
    @apply text-white;
    background: transparent linear-gradient(262deg, #00AFCB 0%, #006295 100%) 0% 0% no-repeat padding-box;
    border-radius: 12px;
    opacity: 1;
  }
  &--secondary {
    @apply bg-white text-primary border-primary;
  }
  &--white {
    @apply bg-white border-white text-primary;
  }
  &--gPaySecondary {
    @apply bg-transparent text-primaryLight;
    border: 1px solid #00AFCB;
  }
  &--gPaySecondaryPrimary {
    @apply bg-transparent text-primary;
    border: 1px solid #006295;
  }
  &--disableGray {
    @apply text-white cursor-pointer;
    background: transparent linear-gradient(262deg, #7D7D7D 0%, #4B4B4B 100%) 0% 0% no-repeat padding-box;
    border-radius: 12px;
    opacity: 1;
  }
  &--error {
    @apply bg-white border-white text-errorColor;
  }
  &:disabled {
    @apply cursor-not-allowed;
  }
  &--normal {
    @apply md:px-8 py-2 px-1;
  }
  &--average {
    @apply py-2 px-1;
  }
  &--small {
    @apply px-4 py-1 text-sm;
  }
}
.dropdown {
  @apply bg-white h-16 rounded-2xl shadow-cardShadow appearance-none min-w-64 text-base focus:outline-none border-none focus:ring-0;
  &:required:invalid {
    @apply text-gray-300;
  }
  option {
    @apply text-textPrimary;
  }
  option[value=""][disabled] {
    display: none;
  }
}
.grey-layout {
  grid-template-rows: auto 1fr;
  @apply bg-greyBackground col-span-full w-full md:py-8 md:px-8 grid content-start gap-4 p-4 relative;
  &--increase-gap {
    @apply gap-8;
  }
}
.home-sidebar {
  grid-template-rows: auto 1fr auto;
  @apply overflow-hidden col-span-1 md:grid justify-items-center bg-greyBackground w-full content-start sticky top-0 hidden h-screen;
}
.label {
  @apply grid gap-1 text-gray-600 text-xs;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.word-wrap {
  word-wrap: anywhere;
}
.boxShadow {
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.01), 0 2px 0px 0 rgba(0, 0, 0, 0.06);
}
.nav-height{
  max-height: 90px;
}

// * {
//   border: 1px solid red;
// }
.blink_me {
    // animation: blinker 1s linear infinite;
    display: inline-block;
    width: 5px;
    overflow: hidden;
    vertical-align: bottom;
    animation: blink_me 2s linear infinite;
    transition: 1;
}
@keyframes blink_me {
    from {
        width: 0px;
    }
    to {
        width: 25px
    }
}
.footer {
  @apply fixed bottom-0 left-0 w-full bg-greyBackground pt-4 pb-6 px-8 text-center grid gap-4 z-20;
}
.nav-footer {
  @apply fixed w-full bottom-0 bg-white pt-2 pb-4 gap-4 text-center grid pr-14;
    box-shadow: #0000004A 0px 1px 15px;
}
.hoverBox:hover{
   box-shadow: 0 4px 8px 0 rgba(0, 98, 149, 0.2), 0 6px 20px 0 rgba(0, 98, 149, 0.19);
}
// blogger
// bold
.heading-text { // 20px
  @apply text-xl font-bold text-headingColor font-blogger
}
.label-text { // 16px
  @apply text-base font-bold text-headingColor font-blogger
}
// semibold
.heading-text-medium { // 20px
  @apply text-xl font-semibold text-headingColor font-blogger
}
.label-text-medium { // 16px
  @apply text-base font-semibold text-headingColor font-blogger
}
// regular
.label-text-normal { // 16px
  @apply text-base text-headingColor font-blogger
}
.label-text-textSecondary { // 16px
  @apply text-base text-textSecondary font-blogger
}
.label-text-headingColor-sm { // 14px
  @apply text-sm text-headingColor font-blogger
}
.label-text-textSecondary-sm { // 14px
  @apply text-sm text-textSecondary font-blogger
}
.secondary-headingColor-text-blogger { // 12px
  @apply text-headingColor font-blogger text-xs
}
.secondary-heading-text-blogger { // 12px
  @apply text-textSecondary font-blogger text-xs
}
// myriad
.label-text-myriad-primary { // 16px
  @apply text-base text-headingColor font-myriad
}
.label-text-myriad { // 16px
  @apply text-base text-textSecondary font-myriad
}
.label-text-myriad { // 14px
  @apply text-sm text-textSecondary font-myriad
}
.label-text-headingColor-myriad { // 14px
  @apply text-sm text-headingColor font-myriad
}
.secondary-heading-text { // 12px
  @apply text-textSecondary font-myriad text-xs
}
.secondary-headingColor-text { // 12px
  @apply text-headingColor font-myriad text-xs
}
@media (min-width: 768px) {
  .bg-up-down-butterfly {
    background-image: url("./assets/up-butterfly.svg"), url("./assets/down-butterfly.svg");
    background-position: right top, left bottom;
    background-repeat: no-repeat, no-repeat;
    &--login-page {
      background-size: 262px 330px, 355px 450px;
    }
  }
  .card-w {
    width: 43.75rem;
  }
}
.bg-down-butterfly-gPay {
  background-image: url("./assets/right-down-butterfly.svg");
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 115px 140px;
}
.inputSearchIcon {
  background: white url("./assets/gray-search.svg") no-repeat;
  background-position: right center;
  background-origin: content-box;
  padding-right: 1rem;
}
.borderCustomizeOutline{
  border: 1px solid #006295;
}
.paddingTop1px{
  padding-top: 1px;
}
.min-width-button {
  min-width: 8rem;
}
.z-index1{
  z-index: 1;
}

// overflowScrollCustom class for custom scrollbar styling

.overflowScrollCustom {
  overflow-y: auto;
}

.overflowScrollCustom::-webkit-scrollbar {
  width: 4px;
}

.overflowScrollCustom::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.overflowScrollCustom::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.overflowScrollCustom::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
